import styles from "./PortalLink.module.css";

/** A zero-height header slot keeps all existing controls in place. */
export default function PortalLink({ viewport = false }: { viewport?: boolean }) {
  return (
    <div className={`${styles.slot}${viewport ? ` ${styles.viewport}` : ""}`}>
      <a
        className={styles.link}
        href="https://home.altadairyinsight.com"
        target="_self"
        aria-label="Zurück zum Alta Portal"
      >
        <span aria-hidden="true">← </span>
        <span className={styles.desktop}>Alta Portal</span>
        <span className={styles.mobile}>Portal</span>
      </a>
    </div>
  );
}